import { render, staticRenderFns } from "./callrecords.vue?vue&type=template&id=8546caa8&scoped=true&"
import script from "./callrecords.vue?vue&type=script&lang=js&"
export * from "./callrecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8546caa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/nico/Projects/ecopbx-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VContainer,VDataTable,VDialog,VDivider,VFlex,VIcon,VLayout,VPagination,VSpacer,VToolbar})
